
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { startConsumosXLote, startConsumoXLote } from "../../../services";




export const useConsumosXLote = (id) => {
    const consumosXLoteQuery = useQuery({
        queryKey: ['consumos-xlote', id], 
        queryFn: () => startConsumosXLote(id),
    });

    return {
        consumosXLoteQuery,
    }
}





export const useConsumoXLote = (id) => {
    
    const [page, setPage] = useState(0);
    const [inicio, setInicio] = useState('');
    const [final, setFinal] = useState('');

    const consumoXLoteQuery = useQuery({
        queryKey: ['consumo-lote', { page, id, inicio, final }], 
        queryFn: () => startConsumoXLote({ page, id, inicio, final }),
    });
    

    const chagePage = (num) => {
        setPage(num - 1);
    }

    const chageInicio = (valor) => {
        setPage(0);
        setInicio(valor)
    }

    const chageFinal = (valor) => {
        setPage(0);
        setFinal(valor)
    }

    
    return {
        // Estados
        page,
        inicio,
        final,
        // Metodos
        chageInicio,
        chageFinal,
        chagePage,
        consumoXLoteQuery,
    }
}





